import { render, staticRenderFns } from "./FreshChatButton.vue?vue&type=template&id=a3936f00&scoped=true&"
import script from "./FreshChatButton.vue?vue&type=script&lang=js&"
export * from "./FreshChatButton.vue?vue&type=script&lang=js&"
import style0 from "./FreshChatButton.vue?vue&type=style&index=0&id=a3936f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3936f00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
